"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parameterise = void 0;
function parameterise(options, f) {
    let permutations = 1;
    const dimensions = Object.entries(options.parameters).map(([key, values]) => {
        const dimension = {
            name: key,
            values,
            only: options.only?.[key],
            not: options.not?.[key],
            size: values.length,
            divisor: permutations,
        };
        permutations *= values.length;
        return dimension;
    });
    for (let i = 0; i < permutations; i++) {
        let skip = false;
        const params = {};
        for (const dimension of dimensions) {
            const offset = Math.floor(i / dimension.divisor) % dimension.size;
            const value = dimension.values[offset];
            if (dimension.only && !dimension.only.includes(value)) {
                skip = true;
            }
            if (dimension.not && dimension.not.includes(value)) {
                skip = true;
            }
            params[dimension.name] = value;
        }
        f(params, skip);
    }
}
exports.parameterise = parameterise;
//# sourceMappingURL=parameterise.js.map